import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import isEarlyAdopter from 'owa-session-store/lib/utils/isEarlyAdopter';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export default function isTabViewEnabled() {
    return isMailFeatureEnabled('rp-tabView') && (!isConsumer() || isEarlyAdopter());
}
//# sourceMappingURL=isTabViewEnabled.js.map